export const texts = {
  imprint: {
    de: 'Impressum',
    en: 'Imprint'
  },
  privacy: {
    de: 'Datenschutz',
    en: 'Privacy'
  }
};
